// extracted by mini-css-extract-plugin
export default {"card-list":"SettingsList_card-list__Z08Br"};